import { StarIcon } from '@heroicons/react/24/solid';
import { cardRating, cardRatingLabel, formatRating } from '@lib/vendor-rating';

/**
 * La calificación de una tarjeta de negocio: una sola, con la fuente escrita («26 en Google»,
 * «6 verificadas»). Qué fuente gana lo decide lib/vendor-rating.js. Sin calificación, nada.
 */
export default function CardRating({ agora, google }) {
  const rating = cardRating({ agora, google });
  if (!rating) return null;
  const title = rating.source === 'agora' ? 'Reseñas verificadas en Ágora' : 'Calificación en Google';
  return (
    <div className="flex items-center gap-1" title={title}>
      <StarIcon className="w-3 h-3 text-amber-400" aria-hidden="true" />
      <span className="text-[12px] font-semibold text-[#1a1a1a] tabular-nums">{formatRating(rating.rating)}</span>
      <span className="text-[11px] text-gray-500">({cardRatingLabel(rating)})</span>
    </div>
  );
}
